module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n        Search By\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.branchRecordWithchangeFilter
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), (_vm.user.type == 'admin' && this.form.branch_id !== '') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Designation"
    }
  }, [_vm._v("Designation")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "designation_id",
      "label": "name",
      "options": _vm.designations,
      "placeholder": "Select Designation"
    },
    on: {
      "input": _vm.getRecordDesignationWise
    },
    model: {
      value: (_vm.designation),
      callback: function($$v) {
        _vm.designation = $$v
      },
      expression: "designation"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "designation_id"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), (_vm.canAccess('staff-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Staff List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [(_vm.canAccess('staff-create')) ? _c('a', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "href": ((this.$axios.defaults.baseURL) + "/staff/export/excel")
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download Excel\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canAccess('staff-create')) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search by Name"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.user.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.user.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.user.email))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.user.alias))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.designation.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.aadharStatus === 'true') ? _c('i', {
      staticClass: "fa fa-check-circle-o text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (row.aadharStatus === 'false') ? _c('i', {
      staticClass: "fa fa-times-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _c('i', {
      staticClass: "fa fa-exclamation-circle text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                " + _vm._s(row.aadhar) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.panStatus === 'true') ? _c('i', {
      staticClass: "fa fa-check text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (row.panStatus === 'false') ? _c('i', {
      staticClass: "fa fa-times text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _c('i', {
      staticClass: "fa fa-exclamation-circle text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                " + _vm._s(row.pan) + "\n              ")]), _vm._v(" "), _c('td', [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.user.mobileVerify == 'true'),
        expression: "row.user.mobileVerify == 'true'"
      }],
      staticClass: "fa fa-check-circle-o text-success"
    }), _vm._v(" " + _vm._s(row.user.mobile))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.user.status))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group"
    }, [_vm._m(1, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu dropdown-menu-right",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.canAccess('staff-view')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.viewModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" View\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('staff-update')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Update\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('staff-delete')) ? _c('li', [_c('a', {
      attrs: {
        "title": "Check Login Status"
      },
      on: {
        "click": function($event) {
          return _vm.loginStatus(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sign-in"
    }), _vm._v(" Login Status\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('staff-view')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.viewIdCardPrintModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" ID Card\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('staff-verify')) ? _c('li', [_c('a', {
      attrs: {
        "title": "Verify"
      },
      on: {
        "click": function($event) {
          return _vm.verifyModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-square"
    }), _vm._v(" Verify\n                      ")])]) : _vm._e()])])])])
  }), 0)])])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Add New Employee")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Edit Employee")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateEmployee() : _vm.createEmployee()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select Company Branch\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\n                                " + _vm._s(branch.name) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('name'),
    },
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Enter Employee Name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name Alias")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.alias),
      expression: "form.alias"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('alias'),
    },
    attrs: {
      "type": "text",
      "name": "alias",
      "placeholder": "Enter Employee Name"
    },
    domProps: {
      "value": (_vm.form.alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "alias", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "alias"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fatherName),
      expression: "form.fatherName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('fatherName'),
    },
    attrs: {
      "type": "text",
      "name": "fatherName",
      "placeholder": "Enter fatherName"
    },
    domProps: {
      "value": (_vm.form.fatherName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "fatherName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "fatherName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dob),
      expression: "form.dob"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('dob'),
    },
    attrs: {
      "type": "date",
      "name": "dob",
      "placeholder": "Enter DOB",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "dob", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "dob"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('email'),
    },
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobile),
      expression: "form.mobile"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('mobile'),
    },
    attrs: {
      "type": "text",
      "name": "mobile",
      "placeholder": "Enter mobile number"
    },
    domProps: {
      "value": (_vm.form.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "mobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Contact Number 2 ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('phone'),
    },
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": "Enter Alternative Number"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.designation_id),
      expression: "form.designation_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'designation_id'
      ),
    },
    attrs: {
      "name": "designation_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "designation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form.designation_id),
      expression: "!form.designation_id"
    }],
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select Designation\n                              ")]), _vm._v(" "), _vm._l((_vm.designations), function(designation) {
    return _c('option', {
      key: designation.id,
      domProps: {
        "value": designation.id
      }
    }, [_vm._v("\n                                " + _vm._s(designation.name) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "designation_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.role_id),
      expression: "form.role_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'role_id'
      ),
    },
    attrs: {
      "name": "role_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "role_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form.role_id),
      expression: "!form.role_id"
    }],
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select Role\n                              ")]), _vm._v(" "), _vm._l((_vm.roles), function(role) {
    return _c('option', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (role.id != 3),
        expression: "role.id != 3"
      }],
      key: role.id,
      domProps: {
        "value": role.id
      }
    }, [_vm._v("\n                                " + _vm._s(role.name) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "role_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.joiningDate),
      expression: "form.joiningDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('joiningDate'),
    },
    attrs: {
      "type": "date",
      "name": "joiningDate",
      "placeholder": "Enter joining Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.joiningDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "joiningDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "joiningDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('password'),
    },
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Enter password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "password"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('address'),
    },
    attrs: {
      "type": "text",
      "name": "address",
      "placeholder": "Enter address"
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.city),
      expression: "form.city"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('city'),
    },
    attrs: {
      "type": "text",
      "name": "city",
      "placeholder": "Enter Employee city"
    },
    domProps: {
      "value": (_vm.form.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.state_id),
      expression: "form.state_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('state_id'),
    },
    attrs: {
      "name": "state_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.state_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select State\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.states), function(stat) {
    return _c('option', {
      key: stat.id,
      domProps: {
        "value": stat.id
      }
    }, [_vm._v("\n                                " + _vm._s(stat.name) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "state_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pin),
      expression: "form.pin"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('pin'),
    },
    attrs: {
      "type": "text",
      "name": "pin",
      "placeholder": "Enter Employee pincode"
    },
    domProps: {
      "value": (_vm.form.pin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "pin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Last Experience")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.lastExperience),
      expression: "form.lastExperience"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'lastExperience'
      ),
    },
    attrs: {
      "type": "text",
      "name": "lastExperience",
      "placeholder": "Enter Last Experience"
    },
    domProps: {
      "value": (_vm.form.lastExperience)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "lastExperience", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "lastExperience"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("Bank Details")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.accountNumber),
      expression: "form.accountNumber"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('accountNumber'),
    },
    attrs: {
      "type": "text",
      "name": "accountNumber",
      "placeholder": "Enter Employee accountNumber"
    },
    domProps: {
      "value": (_vm.form.accountNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "accountNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "accountNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Account Holder Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.accountHolderName),
      expression: "form.accountHolderName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'accountHolderName'
      ),
    },
    attrs: {
      "type": "text",
      "name": "accountHolderName",
      "placeholder": "Enter Employee accountHolderName"
    },
    domProps: {
      "value": (_vm.form.accountHolderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "accountHolderName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "accountHolderName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bank_id),
      expression: "form.bank_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('bank_id'),
    },
    attrs: {
      "name": "bank_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "bank_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.bank_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Bank\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.banks), function(bank) {
    return _c('option', {
      key: bank.id,
      domProps: {
        "value": bank.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank.name) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "bank_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("IFSC Code ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.ifsc),
      expression: "form.ifsc"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('ifsc')
    },
    attrs: {
      "type": "text",
      "name": "ifsc",
      "placeholder": "Enter Employee ifsc"
    },
    domProps: {
      "value": (_vm.form.ifsc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "ifsc", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "ifsc"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Bank Branch ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bank_branch),
      expression: "form.bank_branch"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('bank_branch'),
    },
    attrs: {
      "type": "text",
      "name": "bank_branch",
      "placeholder": "Enter Employee bank_branch"
    },
    domProps: {
      "value": (_vm.form.bank_branch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bank_branch", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "bank_branch"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Aadhar No ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.aadhar),
      expression: "form.aadhar"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('aadhar'),
    },
    attrs: {
      "type": "text",
      "name": "aadhar",
      "placeholder": "Enter Employee aadhar"
    },
    domProps: {
      "value": (_vm.form.aadhar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "aadhar", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "aadhar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Pancard Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pan),
      expression: "form.pan"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('pan')
    },
    attrs: {
      "type": "text",
      "name": "pan",
      "placeholder": "Enter Employee pancard number"
    },
    domProps: {
      "value": (_vm.form.pan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pan", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "pan"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  SAVE\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  UPDATE\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                  CANCEL\n                ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "loginStatus"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.empInfo.user) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\n                          " + _vm._s(_vm.empInfo.user.name) + " \n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center"
  }, [_vm._v("\n                          Code - " + _vm._s(_vm.empInfo.user.code) + " "), _c('br'), _vm._v("\n                          Contact - 91-" + _vm._s(_vm.empInfo.user.mobile) + "\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [(_vm.empInfo.user) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('status'),
    },
    attrs: {
      "name": "status",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.status) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                  Select Status\n                                ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inActive"
    }
  }, [_vm._v("Inactive")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Pending")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": _vm.loginStaffStatus
    }
  }, [_c('b', [_vm._v("Update Login Status")])])])]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _vm._m(22)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "verifyModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(23), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateEmployee() : _vm.createEmployee()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.empInfo.user) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\n                          " + _vm._s(_vm.empInfo.user.name) + " \n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center"
  }, [_vm._v("\n                          Code - " + _vm._s(_vm.empInfo.user.code) + " "), _c('br'), _vm._v("\n                          Contact - 91-" + _vm._s(_vm.empInfo.user.mobile) + "\n                        ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Login Status")]), _vm._v(" "), (_vm.empInfo.user.status == 'active') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("KYC Status")]), _vm._v(" "), (_vm.empInfo.status == 'active') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Mobile Number Status")]), _vm._v(" "), (_vm.empInfo.user.mobileVerify == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Pancard Status")]), _vm._v(" "), (_vm.empInfo.panStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Aadhar Status")]), _vm._v(" "), (_vm.empInfo.aadharStatus == 'true') ? _c('a', {
    staticClass: "pull-right fa fa-check-circle-o text-success"
  }) : _c('a', {
    staticClass: "pull-right fa fa-close text-danger"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.aadhar),
      expression: "form.aadhar"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('aadhar'),
    },
    attrs: {
      "type": "text",
      "name": "aadhar",
      "disabled": "",
      "placeholder": "Enter Employee aadhar"
    },
    domProps: {
      "value": (_vm.form.aadhar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "aadhar", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "aadhar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(25), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.aadharStatus),
      expression: "form.aadharStatus"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('aadharStatus'),
    },
    attrs: {
      "name": "aadharStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "aadharStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.aadharStatus) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                  Select Aadhar Status\n                                ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "aadharStatus"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(26), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pan),
      expression: "form.pan"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('pan')
    },
    attrs: {
      "type": "text",
      "name": "pan",
      "disabled": "",
      "placeholder": "Enter Employee pancard number"
    },
    domProps: {
      "value": (_vm.form.pan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "pan", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "pan"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(27), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.panStatus),
      expression: "form.panStatus"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('panStatus'),
    },
    attrs: {
      "name": "panStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "panStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.panStatus) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                  Select Pancard Status\n                                ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "panStatus"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(28), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reason_id),
      expression: "form.reason_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('reason_id'),
    },
    attrs: {
      "name": "reason_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "reason_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.reason_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                  Select Reason\n                                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.reasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v("\n                                  " + _vm._s(reason.reason) + "\n                                ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "reason_id"
    }
  })], 1)])]), _vm._v(" "), (_vm.empInfo.user) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('status'),
    },
    attrs: {
      "name": "status",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.status) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                    Select Status\n                                  ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inActive"
    }
  }, [_vm._v("Inactive")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Pending")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.empInfo.user.mobileVerify != 'true'),
      expression: "empInfo.user.mobileVerify != 'true'"
    }],
    staticClass: "col-md-6 col-xs-12"
  }, [_vm._m(30), _vm._v(" "), _c('strong', [_c('input', {
    staticClass: "btn btn-info btn-block",
    attrs: {
      "type": "button",
      "value": "Send OTP To Mobile"
    },
    on: {
      "click": _vm.sendOTP
    }
  })]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.otp),
      expression: "form.otp"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'otp'
      ),
    },
    attrs: {
      "type": "text",
      "name": "otp",
      "placeholder": "Please Enter OTP"
    },
    domProps: {
      "value": (_vm.form.otp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "otp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "otp"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendOTPVerify
    }
  }, [_c('strong', [_vm._v("Verify OTP")])])])], 1)])]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  SAVE\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  UPDATE\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                  CANCEL\n                ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.empInfo.user) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "profile-user-img img-fluid img-circle",
    attrs: {
      "src": this.photo,
      "alt": "User profile picture"
    }
  })]), _vm._v(" "), (_vm.empInfo.status !== 'verified') ? _c('div', [(_vm.empInfo.photoStatus != 'true') ? _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.uploadPhoto($event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "profile-username text-center"
  }, [_vm._v("\n                        " + _vm._s(_vm.empInfo.user.name) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted text-center"
  }, [_vm._v("\n                        " + _vm._s(_vm.empInfo.designation.name) + "\n                      ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Employee Code")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.empInfo.user.code))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.empInfo.branch.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Phone Number")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.empInfo.user.mobile))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("City")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.empInfo.city))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("DOB")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.empInfo.dob))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Joining Date")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.empInfo.joiningDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Status")]), _vm._v(" "), _c('a', {
    staticClass: "float-right"
  }, [_vm._v(_vm._s(_vm.empInfo.status))])])]), _vm._v(" "), _vm._m(32)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "activity"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._m(35), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.fatherName) + "\n                              ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.address) + "\n                              ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.empInfo.city))]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.state.name) + "\n                              ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(39), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.lastExperience) + "\n                              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "timeline"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._m(41), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.accountHolderName) + "\n                              ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(42), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.accountNumber) + "\n                              ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(43), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [(_vm.empInfo.bank) ? _c('i', [_vm._v(_vm._s(_vm.empInfo.bank.name) + ",")]) : _vm._e(), _vm._v("\n                                " + _vm._s(_vm.empInfo.bank_branch) + ", IFSC Code -\n                                " + _vm._s(_vm.empInfo.ifsc) + "\n                              ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('span', {
    staticClass: "tag tag-danger"
  }, [_vm._v(_vm._s(_vm.empInfo.pan))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.empInfo.aadhar))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "earnings"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(46), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._m(47), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.basicSalary) + "\n                              ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.fixedAllowance) + "\n                              ")]), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "deduction"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(49), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._m(50), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.fixedDeduction) + "\n                              ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.incomeTax) + "\n                              ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.numberOfMonthForFixedDeduction) + "\n                              ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(53), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                " + _vm._s(_vm.empInfo.numberOfMonthIncomeTax) + "\n                              ")]), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "annualy"
    }
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_vm._m(54), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(55), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                    " + _vm._s(_vm.empInfo.sickLeave) + "\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(56), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                    " + _vm._s(_vm.empInfo.previlageLeave) + "\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(57), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                    " + _vm._s(_vm.empInfo.maternityLeave) + "\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                    " + _vm._s(_vm.empInfo.paternityLeave) + "\n                                  ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(59), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                    " + _vm._s(_vm.empInfo.mandatoryLeave) + "\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(60), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                    " + _vm._s(_vm.empInfo.extraOrdinaryLeave) + "\n                                  ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                    " + _vm._s(_vm.empInfo.casualLeave) + "\n                                  ")]), _vm._v(" "), _c('hr')])])])])])])])])])]) : _vm._e()]), _vm._v(" "), _vm._m(62)])])]), _vm._v(" "), _c('employeeidcard', {
    attrs: {
      "empInfo": _vm.empInfo,
      "logo": _vm.logo,
      "getCompanyRecord": _vm.getCompanyRecord,
      "photo": _vm.photo
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr.")]), _vm._v(" "), _c('th', [_vm._v("Code ")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Alias")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Designation")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("AadharCardNumber")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("PancardNumber")]), _vm._v(" "), _c('th', [_vm._v("Mobile")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("KYC Status")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Login Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-flat btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                    Task "), _c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Father Name"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("DOB Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Contact Email "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Contact Number 1"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Designation "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Staff Role "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Joining Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Password "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Address "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("City "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select State "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Pincode "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Bank Account Number"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Bank Name"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Staff Login Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Staff Login Status ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                  CANCEL\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Verify Employee Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Aadhar No "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Aadhar Status "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Pancard Number "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Pancard Status "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Reason "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Staff KYC Status ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Staff Mobile Verify")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Employee Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "#"
    }
  }, [_c('b', [_vm._v("Short Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header p-2"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#activity",
      "data-toggle": "tab"
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline",
      "data-toggle": "tab"
    }
  }, [_vm._v("Bank Details")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#earnings",
      "data-toggle": "tab"
    }
  }, [_vm._v("Earnings")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deduction",
      "data-toggle": "tab"
    }
  }, [_vm._v("Deduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#annualy",
      "data-toggle": "tab"
    }
  }, [_vm._v("Annualy")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Profile Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-user mr-1"
  }), _vm._v(" Father\n                                Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-map-marker-alt mr-1"
  }), _vm._v("\n                                Address")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-map-marker-alt mr-1"
  }), _vm._v("\n                                City")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-map-marker-alt mr-1"
  }), _vm._v("\n                                State")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "far fa-file-alt mr-1"
  }), _vm._v(" Previous\n                                Experience")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-user mr-1"
  }), _vm._v(" Account\n                                Holder Name")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-book mr-1"
  }), _vm._v(" Bank Account\n                                Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-map-marker-alt mr-1"
  }), _vm._v("Bank Name & Branch Name & IFSC Code")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-pencil-alt mr-1"
  }), _vm._v("\n                                Pancard Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fas fa-pencil-alt mr-1"
  }), _vm._v(" Adhar\n                                Card Number")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Earnings Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-rupee-sign mr-1"
  }), _vm._v(" Basic\n                                Salary (Annual)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-rupee-sign mr-1"
  }), _vm._v(" Fixed\n                                Allowance")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Deduction Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-rupee-sign mr-1"
  }), _vm._v(" Fixed\n                                Deduction (in Month)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-rupee-sign mr-1"
  }), _vm._v(" Income\n                                Tax (in Month)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-pencil-alt mr-1"
  }), _vm._v(" Number\n                                of Month for Fixed Deduction")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-pencil-alt mr-1"
  }), _vm._v(" Number\n                                of Month Income Tax")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Annualy Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-cash-register mr-1"
  }), _vm._v("\n                                    Sick Leave(Annualy)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-cash-register mr-1"
  }), _vm._v("\n                                    Previlage Leave")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-cash-register mr-1"
  }), _vm._v("\n                                    Maternity Leave")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-cash-register mr-1"
  }), _vm._v("\n                                    Paternity Leave")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-cash-register mr-1"
  }), _vm._v("\n                                    Mandatory Leave")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-cash-register mr-1"
  }), _vm._v("\n                                    Extra Ordinary Leave")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-cash-register mr-1"
  }), _vm._v("\n                                    Casual Leaves (Annually)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CLOSE\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a4c8398!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/HRM/Employee.vue
// module id = 802
// module chunks = 0